module.exports = __webpack_public_path__ + "img/close-x.ba00d3b5.svg";